export function nullIfNthArgNegative (fn, index) {
  return (...args) => {
    if (!args[index]) {
      return null;
    }

    return fn(...args);
  };
}

export function nullIfFirstArgNegative (fn) {
  return nullIfNthArgNegative(fn, 0);
}

export function nullIfArgByIndexesNegative (fn, indexes) {
  return (...args) => {
    const someArgIsNegative = indexes
      .some((index) => {
        return !args[index];
      });

    if (someArgIsNegative) {
      return null;
    }

    return fn(...args);
  };
}

export function fromOwnProp (prop) {
  return (state, ownProps) => {
    return ownProps[prop];
  }
}

export function logAsyncError(fn) {
  return async (...args) => {
    try {
      return await fn(...args);
    } catch (e) {
      Logger.error(e);
    }
  }
}
